import i18nFactory from '@yandex-int/i18n';
import { noop } from 'lodash';
import React from 'react';

import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { Loader } from '../../components/Loader/Loader';
import { Bem } from '../../service/Bem/Bem';
import { CreativesBatch } from '../BatchesList/typings';
import { CanvasFooter } from '../CanvasFooter/CanvasFooter';
import { CommonCreativeRenderer } from '../CommonCreativeRenderer/CommonCreativeRenderer';
import { CommonCreativesViewer } from '../CommonCreativesViewer/CommonCreativesViewer';
import { Html5Filter } from '../Html5Filter/Html5Filter';
import { InfiniteList } from '../InfiniteList/InfiniteList';

import './Html5Archive.css';
import * as keyset from './Html5Archive.i18n';
import { Html5ArchiveProps } from './typings';

const BLOCK = 'html5-archive';
const i18n = i18nFactory(keyset);

class ArchiveBatchRenderer extends React.PureComponent<{
    batch: CreativesBatch;
    showCreativesSelector: (id: string) => void;
}> {
    render() {
        const { batch } = this.props;
        const rendererData = {
            thumbnail: batch.thumbnail,
            alt: ''
        };

        return (
            <div className={Bem.cls(BLOCK, 'item')}>
                <CommonCreativeRenderer item={rendererData} />
                <div className={Bem.cls(BLOCK, 'info')}>
                    <span className={Bem.cls(BLOCK, 'name')}>{batch.name}</span>
                    <ButtonDecorator
                        cls={Bem.cls(BLOCK, 'view-btn')}
                        text={i18n('view')}
                        theme={'action'}
                        size={'s'}
                        onClick={this.onViewClick}
                    />
                </div>
            </div>
        );
    }

    private onViewClick = () => {
        this.props.showCreativesSelector(this.props.batch.id);
    };
}

export class Html5Archive extends React.PureComponent<Html5ArchiveProps> {
    componentDidMount(): void {
        if (this.props.needRefresh) {
            const { order, creativeSizes, filterText } = this.props.filter;
            this.props.loadItems(0, order, creativeSizes, filterText);
        }
    }

    render() {
        return (
            <div className={Bem.cls(BLOCK)}>
                {this.props.isBusy && <Loader size={'s'} />}
                <Html5Filter
                    {...this.props.filter}
                    applySizesFilter={this.props.applySizesFilter}
                    loadItems={this.props.loadItems}
                />
                <div className={Bem.cls(BLOCK, 'list')}>{this.getBatchesList()}</div>
                <CanvasFooter
                    cls={Bem.cls(BLOCK, 'footer')}
                    submitEnabled={false}
                    submitVisible={false}
                    submitLabel={''}
                    cancelLabel={i18n('cancel')}
                    error={this.props.error}
                    hideError={this.props.hideError}
                    submit={noop}
                    cancel={this.props.cancel}
                />
            </div>
        );
    }

    getBatchesList() {
        const {
            collection: { batches },
            creativesSelectorVisible,
            creativesSelectorDataProvider
        } = this.props.batchesList;

        if (this.props.isBusy || batches.length > 0) {
            return (
                <>
                    {creativesSelectorVisible && (
                        <CommonCreativesViewer
                            items={creativesSelectorDataProvider}
                            cancel={this.props.hideCreativesSelector}
                        />
                    )}
                    <InfiniteList
                        content={
                            <>
                                {batches.map(batch => {
                                    return (
                                        <ArchiveBatchRenderer
                                            key={batch.id}
                                            batch={batch}
                                            showCreativesSelector={this.props.showCreativesSelector}
                                        />
                                    );
                                })}
                            </>
                        }
                        scrollAtBottom={this.scrollAtBottom}
                    />
                </>
            );
        } else {
            return <div className={Bem.cls(BLOCK, 'empty-message')}>{i18n('no-creatives')}</div>;
        }
    }

    private scrollAtBottom = () => {
        const { collection } = this.props.batchesList;
        const offset = collection.batches.length;
        if (offset < collection.total) {
            this.props.loadItems(
                offset,
                this.props.filter.order,
                this.props.filter.creativeSizes,
                this.props.filter.filterText
            );
        }
    };
}
